import { styled } from "style";

const Box = styled("div")({});

export default Box;
